import antd from 'antd/lib/locale-provider/nl_BE';
import appLocaleData from 'react-intl/locale-data/nl';
import globalData from './layouts/global.json';
import error from './layouts/error.json';
import topbar from './layouts/Main/topbar.json';
import sidebar from './layouts/Main/sidebar.json';
import dashboard from './containers/Dashboard/index.json';
import carrier from './containers/ProductFactory/CarrierContainer.json';
import property from './containers/ProductFactory/PropertyContainer.json';
import configuration from './containers/ProductFactory/ConfigurationContainer.json';
import packages from './containers/ProductFactory/PackageContainer.json';
import templates from './containers/ProductFactory/TemplateContainer.json';
import user from './containers/Users/UserContainer.json';
import userGroup from './containers/Users/GroupContainer.json';
import errorPages from './containers/ErrorPages/index.json';
import profile from './containers/Profile/index.json';
import partner from './containers/AdvancedSettings/PartnerContainer.json';
import reseller from './containers/AdvancedSettings/ResellerContainer.json';
import history from './components/History.json';
import popInfos from './components/PopInfos.json';
import costs from './containers/Costs/index.json';
import productGroup from './containers/MarketingSales/ProductGroupContainer.json';
import segment from './containers/MarketingSales/SegmentContainer.json';
import discount from './containers/MarketingSales/DiscountContainer.json';
import promotion from './containers/MarketingSales/PromotionContainer.json';
import translation from './containers/MarketingSales/TranslationContainer.json';
import customer from './containers/Customers/index.json';
import order from './containers/Orders/index.json';
import quote from './containers/Quotes/index.json';
import imports from './containers/Imports/index.json';
import form from './containers/ProductionPlanning/FormContainer.json';
import jobResult from './containers/ProductionPlanning/JobResultContainer.json';
import rollIn from './containers/ProductionPlanning/RollInContainer.json';
import rollOut from './containers/ProductionPlanning/RollOutContainer.json';
import formVersion from './containers/ProductionPlanning/FormVersionContainer.json';
import machine from './containers/ProductionPlanning/MachineContainer.json';
import coatingIn from './containers/ProductionPlanning/CoatingInContainer.json';
import coatingOut from './containers/ProductionPlanning/CoatingOutContainer.json';
import job from './containers/ProductionPlanning/JobContainer.json';
import packaging from './containers/ProductionPlanning/PackagingContainer.json';
import planning from './containers/ProductionPlanning/PlanningContainer.json';
import prepress from './containers/ProductionPlanning/PrepressContainer.json';
import designLibraryList from './containers/DesignLibrary/ListContainer.json';
import designLibrarySettings from './containers/DesignLibrary/SettingsContainer.json';
import logistic from './containers/Logistics/logistic.json';
import box from './containers/Logistics/box.json';
import emailTemplates from './containers/AdvancedSettings/EmailTemplates.json';
import shippingType from './containers/AdvancedSettings/ShippingType.json';
import paymentType from './containers/AdvancedSettings/PaymentType.json';
import store from './containers/AdvancedSettings/Store.json';
import accountancy from './containers/Accountancy/index.json';

const locale = {
    messages: {
        ...topbar,
        ...sidebar,
        ...dashboard,
        ...carrier,
        ...property,
        ...configuration,
        ...packages,
        ...templates,
        ...user,
        ...userGroup,
        ...globalData,
        ...error,
        ...errorPages,
        ...profile,
        ...partner,
        ...reseller,
        ...history,
        ...popInfos,
        ...costs,
        ...productGroup,
        ...segment,
        ...discount,
        ...promotion,
        ...translation,
        ...customer,
        ...order,
        ...quote,
        ...imports,
        ...form,
        ...jobResult,
        ...rollIn,
        ...rollOut,
        ...formVersion,
        ...machine,
        ...coatingIn,
        ...coatingOut,
        ...job,
        ...planning,
        ...packaging,
        ...prepress,
        ...designLibraryList,
        ...designLibrarySettings,
        ...logistic,
        ...box,
        ...emailTemplates,
        ...shippingType,
        ...paymentType,
        ...store,
        ...accountancy,
    },
    antd,
    data: appLocaleData,
    locale: 'nl-BE',
};

export default locale;
